import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
export const getAdditionalRegistrationInformation = () => {
  const {
    connectionType
  } = CrossTabConfig.get();
  return {
    // local Calling SDK developement support
    connectionType
  };
};